export interface ClinicCatalogFilter {
  page: number;
  pageSize: number;

  sortCriteria?: ClinicCatalogSorting;
  openTasks?: Array<ClinicCatalogOpenTaksFilter>;
  searchTerm?: string;
}

export type ClinicCatalogSorting = `${'-' | ''}${'name' | 'lastStaging'}`;

export enum ClinicCatalogOpenTaksFilter {
  ORGANIZATION = 'organizationAssignment',
  PACKAGING_UNITS_ASGMT = 'packagingUnitsAssignment',
}
